import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: 6,
				padding: 10,
				marginTop: 16
			},
			header: {
				fontSize: 16,
				color: theme.palette.primary.contrastText,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`,
				paddingBottom: 10,
				fontWeight: 500
			},
			textTime: {
				fontSize: 14,
				marginTop: 7,
				color: theme.palette.primary.contrastText
			},
			valueTime: {
				color: theme.palette.error.light
			}
		}),
	{
		name: "InfoPromotion",
		index: 1
	}
);

export default useStyles;
